import { ServiceNames, BaseParentDocumentService } from "./BaseDocumentService";
import { OpportunityData } from "@/models/OpportunityData";

export class OpportunityService extends BaseParentDocumentService<
  OpportunityData
> {
  serviceName = ServiceNames.Opportunities;
}
